// components/CreateTicket.jsx
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppServices } from "../../../../hook/services";

const CreateTicket = () => {
  const AppService = useAppServices();
  const { companyId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    loomVideoUrl: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    } else if (formData.subject.length < 5) {
      newErrors.subject = "Subject must be at least 5 characters";
    }

    if (!formData.description.trim()) {
      newErrors.description = "Description is required";
    } else if (formData.description.length < 10) {
      newErrors.description =
        "Please provide more details (min. 10 characters)";
    }

    if (formData.loomVideoUrl && !isValidLoomUrl(formData.loomVideoUrl)) {
      newErrors.loomVideoUrl = "Please enter a valid Loom video URL";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isValidLoomUrl = (url) => {
    const loomRegex =
      /^(https?:\/\/)?(www\.)?loom\.com\/(share|embed)\/[a-zA-Z0-9]+$/;
    return loomRegex.test(url.trim());
  };
  const generateTicketId = () => {
    return "TKT-" + Math.random().toString(36).substr(2, 9).toUpperCase();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const ticket_id = generateTicketId();

    setIsSubmitting(true);
    // if (!validateForm()) {
    //   return;
    // }
    const payload = {
      ...formData,
      email: "zohaib@gmail.com",
      firstName: "Zohaib",
      lastName: "Ali",
      companyId,
      ticket_id,
    };
    const { response } = await AppService.support.create_ticket({ payload });
    if (response) {
      setIsSubmitting(false);
      navigate(-1);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const extractLoomId = (url) => {
    const match = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
    return match ? match[1] : null;
  };

  return (
    <div className="card pro-card shadow-sm">
      <div className="card-header pro-card-header">
        <h2 className="h5 mb-0 fw-semibold">
          <i className="bi bi-plus-circle me-2"></i>
          Create New Support Ticket
        </h2>
        <p className="text-muted small mb-0 mt-1">
          Fill in the details below to create a new support ticket
        </p>
      </div>

      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {/* Subject Field */}
          <div className="mb-4">
            <label htmlFor="subject" className="form-label fw-semibold">
              <i className="bi bi-chat-left-text me-2"></i>
              Ticket Subject <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control pro-form-control ${
                errors.subject ? "is-invalid" : ""
              }`}
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Brief, descriptive title of your issue"
            />
            {errors.subject ? (
              <div className="invalid-feedback d-flex align-items-center">
                <i className="bi bi-exclamation-circle me-2"></i>
                {errors.subject}
              </div>
            ) : (
              <small className="text-muted">
                Be specific. Example: "Unable to upload files larger than 10MB"
              </small>
            )}
          </div>

          {/* Description Field */}
          <div className="mb-4">
            <label htmlFor="description" className="form-label fw-semibold">
              <i className="bi bi-card-text me-2"></i>
              Detailed Description <span className="text-danger">*</span>
            </label>
            <textarea
              className={`form-control pro-form-control ${
                errors.description ? "is-invalid" : ""
              }`}
              id="description"
              name="description"
              rows="6"
              value={formData.description}
              onChange={handleChange}
              placeholder="Please provide detailed information about your issue. Include: 
• Steps to reproduce the problem
• What you expected to happen
• What actually happened
• Any error messages
• Browser/device information"
            />
            {errors.description ? (
              <div className="invalid-feedback d-flex align-items-center">
                <i className="bi bi-exclamation-circle me-2"></i>
                {errors.description}
              </div>
            ) : (
              <small className="text-muted">
                The more details you provide, the faster we can help you.
              </small>
            )}
          </div>

          {/* Loom Video Field */}
          <div className="mb-4">
            <label htmlFor="loomVideoUrl" className="form-label fw-semibold">
              <i className="bi bi-camera-reels me-2"></i>
              Loom Video URL (Optional)
            </label>
            <input
              type="url"
              className={`form-control pro-form-control ${
                errors.loomVideoUrl ? "is-invalid" : ""
              }`}
              id="loomVideoUrl"
              name="loomVideoUrl"
              value={formData.loomVideoUrl}
              onChange={handleChange}
              placeholder="https://www.loom.com/share/your-video-id"
            />
            {errors.loomVideoUrl ? (
              <div className="invalid-feedback d-flex align-items-center">
                <i className="bi bi-exclamation-circle me-2"></i>
                {errors.loomVideoUrl}
              </div>
            ) : (
              <small className="text-muted">
                Share a Loom video to better explain your issue
              </small>
            )}

            {/* Loom Video Preview */}
            {formData.loomVideoUrl &&
              !errors.loomVideoUrl &&
              isValidLoomUrl(formData.loomVideoUrl) && (
                <div className="mt-3">
                  <div className="card border">
                    <div className="card-body">
                      <h6 className="fw-semibold mb-3">
                        <i className="bi bi-play-circle me-2"></i>
                        Loom Video Preview
                      </h6>
                      <div className="ratio ratio-16x9">
                        <iframe
                          src={`https://www.loom.com/embed/${extractLoomId(
                            formData.loomVideoUrl
                          )}`}
                          frameBorder="0"
                          allowFullScreen
                          title="Loom video player"
                        ></iframe>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <small className="text-muted">
                          <i className="bi bi-info-circle me-1"></i>
                          Your video will be attached to the ticket
                        </small>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              loomVideoUrl: "",
                            }))
                          }
                        >
                          <i className="bi bi-x me-1"></i>
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {/* Loom Help Text */}
            <div className="mt-2">
              <div className="alert alert-light border small">
                <div className="d-flex">
                  <i className="bi bi-lightbulb text-warning me-2"></i>
                  <div>
                    <strong>Tip:</strong> Recording a Loom video is the fastest
                    way to explain technical issues.
                    <div className="mt-1">
                      <a
                        href="https://www.loom.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none"
                      >
                        <i className="bi bi-box-arrow-up-right me-1"></i>
                        Get Loom here
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="d-flex justify-content-between pt-4 border-top">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => navigate(-1)}
              disabled={isSubmitting}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancel
            </button>

            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  setFormData({
                    subject: "",
                    description: "",
                    loomVideoUrl: "",
                  });
                  setErrors({});
                }}
                disabled={isSubmitting}
              >
                <i className="bi bi-arrow-clockwise me-2"></i>
                Clear All
              </button>

              <button
                type="submit"
                className="btn btn-secondary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Creating Ticket...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle me-2"></i>
                    Create Support Ticket
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTicket;
